<template>
  <div class="class-charts">
    <!-- 分类得分情况 -->
    <div class="canvas-box" id="myBarChart"></div>
  </div>
</template>
<script>
import { bar } from "../echarts/config";
export default {
  props: ["model"],
  data() {
    return {
      bar: bar,
    };
  },
  mounted() {
    if (this.model) {
      this.renderMap();
    }
  },
  watch: {
    model(val) {
      if (val) {
        this.renderMap();
      }
    },
  },
  methods: {
    renderMap() {
      let score = [];
      if (this.model) {
        let value = this.model.split(",");
        if (value.length == 3) {
          score = value;
        }
      }
      let myBarChart = (window.cc = this.$echarts.init(
        document.getElementById("myBarChart")
      ));
      let names = this.bar.map((item) => {
        return item.name;
      });
      let option = {
        backgroundColor: "#fff",
        legend: {
          data: ["正确题目数", "总题目数"],
          left: 35,
          itemWidth: 14,
        },
        grid: {
          left: "3%",
          right: "10%",
          containLabel: true,
          height: 400,
        },
        xAxis: {
          type: "category",
          data: names,
          minInterval: 100,
        },
        yAxis: {
          type: "value",
          show: true,
        },
        graphic: [
          {
            type: "text",
            right: "0px",
            top: "440",
            style: {
              text: "题型",
            },
          },
        ],
        series: [
          {
            name: "总题目数",
            type: "bar",
            color: "#dedede",
            data: [10, 10, 10],
            barWidth: 30,
            barGap: "-100%",
          },
          {
            name: "正确题目数",
            type: "bar",
            color: "#000080",
            data: score,
            barWidth: 30,
          },
        ],
      };
      myBarChart.setOption(option);

      let that = this;
      setTimeout(function() {
        that.getBaseImage(myBarChart);
      }, 1000);
    },
    getBaseImage(chart) {
      let imgData = chart.getDataURL({
        pixelRatio: 2,
        backgroundColor: "#fff",
      });

      // // 向父组件传图片base64格式
      // this.$parent.$parent.$parent.$parent.$parent.setImageBase(this.image1);
      this.$emit("image4", imgData);
    },
  },
};
</script>

<style lang="scss" scoped>
.class-charts {
  position: relative;
  .canvas-box {
    width: 600px;
    height: 500px;
    margin: 10px auto 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dataView/echarts/classScore.vue